<template>
    <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" @cancel="handleCancel">
        <a-form ref="formRef" :model="formState" :rules="rules" :label-col="{ style: { width: '110px' } }"
            :wrapper-col="{ style: { width: '300px' } }">
            <template v-if="modalConfig.role === 'qualityInspector'">

                <a-form-item label="生产日期" name="produceDate">
                    <a-date-picker v-model:value="formState.produceDate"
                        @change="(e, stringTime) => formState.produceDate = stringTime" placeholder="请选择生产日期"
                        allowClear></a-date-picker>
                </a-form-item>

                <a-form-item label="送检工序" name="submittedProcess">
                    <a-select v-model:value="formState.submittedProcess" :options="PQCProductOption"
                        placeholder="请选择送检工序" allowClear></a-select>
                </a-form-item>

                <a-form-item label="送检人" name="submittedBy">
                    <a-input v-model:value="formState.submittedBy" placeholder="送检人" allowClear></a-input>
                </a-form-item>
                <a-form-item label="送检日期" name="submittedDate">
                    <a-date-picker v-model:value="formState.submittedDate" placeholder="送检日期"
                        @change="(e, stringTime) => formState.submittedDate = stringTime" allowClear></a-date-picker>
                </a-form-item>

                <a-form-item label="设备型号" name="model">
                    <a-select v-model:value="formState.model" placeholder="设备型号" allowClear>
                        <a-select value="Swan 600">Swan600</a-select>
                        <a-select value="Swan 600P">Swan600P</a-select>
                        <a-select value="Swan 700">Swan700</a-select>
                        <a-select value="Swan 700P">Swan700P</a-select>
                    </a-select>
                </a-form-item>

                <a-form-item label="机器信息" name="serial">
                    <a-input v-model:value="formState.serial" placeholder="请输入SN号/机身号" allowClear></a-input>
                </a-form-item>

                <a-form-item label="状态" name="status">
                    <a-select v-model:value="formState.status" placeholder="请选择状态" allowClear
                        :disabled="!(formState.status === '' || formState !== '现场处理')">
                        <a-select-option value="现场处理">现场处理</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="问题现象" name="problemPhenomenon">
                    <after-sale-qeustion-vue :questionLists="formState.problemPhenomenon" noticeText="请输入问题现象"
                        textAreaStyle="width: 320px" ref="questionRef"></after-sale-qeustion-vue>
                </a-form-item>

                <a-form-item label="问题图片" name="picture">
                    <upload-img-vue :attachment="formState.picture" ref="uploadImg" uploadFileName="files"
                        :requestFn="uploadQualityInspection"></upload-img-vue>
                </a-form-item>

                <a-form-item label="问题视频" name="video">
                    <upload-video-vue :attachment="formState.video" ref="uploadVideo" uploadFileName="files"
                        :requestFn="uploadQualityInspection"></upload-video-vue>
                </a-form-item>
            </template>

            <template v-else-if="modalConfig.role === 'supplyChain'">
                <a-form-item label="生产日期" name="produceDate">
                    <a-date-picker v-model:value="formState.produceDate"
                        @change="(e, stringTime) => formState.produceDate = stringTime" placeholder="请选择生产日期" disabled
                        allowClear></a-date-picker>
                </a-form-item>

                <a-form-item label="送检工序" name="submittedProcess">
                    <a-select v-model:value="formState.submittedProcess" :options="PQCProductOption"
                        placeholder="请选择送检工序" disabled allowClear></a-select>
                </a-form-item>

                <a-form-item label="送检人" name="submittedBy">
                    <a-input v-model:value="formState.submittedBy" placeholder="送检人" disabled allowClear></a-input>
                </a-form-item>
                <a-form-item label="送检日期" name="submittedDate">
                    <a-date-picker v-model:value="formState.submittedDate" placeholder="送检日期"
                        @change="(e, stringTime) => formState.submittedDate = stringTime" disabled
                        allowClear></a-date-picker>
                </a-form-item>

                <a-form-item label="设备型号" name="model">
                    <a-select v-model:value="formState.model" placeholder="设备型号" disabled allowClear>
                        <a-select-option value="Swan600">Swan600</a-select-option>
                        <a-select-option value="Swan600P">Swan600P</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="机器信息" name="serial">
                    <a-input v-model:value="formState.serial" placeholder="请输入机器信息" disabled allowClear></a-input>
                </a-form-item>

                <a-form-item label="问题现象" name="problemPhenomenon">
                    <after-sale-qeustion-vue :disabled="true" :questionLists="formState.problemPhenomenon"
                        textAreaStyle="width: 320px" ref="questionRef"></after-sale-qeustion-vue>
                </a-form-item>

                <a-form-item label="问题图片" name="picture" v-if="formState.picture && formState.picture !== '[]'">
                    <upload-img-vue :disabled="true" :attachment="formState.picture" ref="uploadImg"></upload-img-vue>
                </a-form-item>

                <a-form-item label="问题视频" name="video" v-if="formState.video && formState.video !== '[]'">
                    <upload-video-vue :disabled="true" :attachment="formState.video"
                        ref="uploadVideo"></upload-video-vue>
                </a-form-item>

                <div class="line">

                </div>

                <a-form-item label="通知人">
                    <staff :echoStaff="toRaw(formState).recipient ? toRaw(formState).recipient.split(',')[1] : null"
                        :echostaffUserName="toRaw(formState).recipient ? toRaw(formState).recipient.split(',')[0] : null"
                        @getChooseStaff="getChooseStaff($event, 'recipient')"></staff>
                </a-form-item>

                <a-form-item label="情况确认和分析" name="confirmationAndAnalysis">
                    <a-textarea v-model:value="formState.confirmationAndAnalysis"
                        :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="情况确认和分析" allowClear></a-textarea>
                </a-form-item>

                <a-form-item label="分析部门" name="analysisDept">
                    <staff :echoStaff="toRaw(formState).analysisDept?.split(',')[1]"
                        :echostaffUserName="toRaw(formState).analysisDept?.split(',')[0]"
                        @getChooseStaff="getChooseStaff($event, 'analysisDept')"
                        :appointDepartment="['工程部', '试产中心', '研发中心']"></staff>
                </a-form-item>

                <a-form-item label="问题类型" name="problemType">
                    <a-select v-model:value="formState.problemType" :options="questionTypeOptions" allowClear
                        placeholder="请选择问题类型">
                    </a-select>
                </a-form-item>


                <a-form-item label="根本原因" name="rootCauseAnalysisTemplateId">
                    <a-select :options="rootCauseAnalysisOptions" v-model:value="formState.rootCauseAnalysisTemplateId"
                        :dropdownMatchSelectWidth="false" @change="handleSelectRootTemplate" placeholder="请选择根本原因"
                        allowClear>
                    </a-select>
                </a-form-item>

                <template v-if="formState.rootCauseAnalysisTemplateId">
                    <a-form-item label="临时措施" name="temporaryMeasures">
                        <a-textarea disabled v-model:value="formState.temporaryMeasures"
                            :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="请输入临时措施" allowClear></a-textarea>
                    </a-form-item>

                    <a-form-item label="闭环措施" name="closedLoopMeasures">
                        <a-textarea disabled v-model:value="formState.closedLoopMeasures"
                            :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="请输入闭环措施" allowClear></a-textarea>
                    </a-form-item>

                    <a-form-item label="确认执行" name="implementationMeasures">
                        <a-textarea disabled v-model:value="formState.implementationMeasures"
                            :auto-size="{ minRows: 1, maxRows: 10 }" placeholder="请输入确认执行" allowClear>
                        </a-textarea>
                    </a-form-item>
                </template>
                <a-form-item label="状态" name="status">
                    <a-select v-model:value="formState.status" placeholder="请选择状态" allowClear>
                        <a-select-option value="分析中">分析中</a-select-option>
                        <a-select-option value="进行中">进行中</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="执行部门" name="executionDept">
                    <staff :echoStaff="toRaw(formState).executionDept?.split(',')[1]"
                        :echostaffUserName="toRaw(formState).executionDept?.split(',')[0]"
                        @getChooseStaff="getChooseStaff($event, 'executionDept')"></staff>
                </a-form-item>

            </template>

            <a-form-item label="备注" name="notes">
                <a-textarea v-model:value="formState.notes" placeholder="备注" :auto-size="{ minRows: 1, maxRows: 10 }"
                    allowClear></a-textarea>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import { defineComponent, reactive, ref, toRaw } from "vue";
import { useStore } from "vuex";
import { Toast, debounce, timeStampToTime, uploadMedia } from "@/utils";
import { saveQualityInspectionProblem, uploadQualityInspection } from '@/request/view/dailyQualityInspection.js';
import { getRootCauseAnalysisTemplateList } from '@/request/view/afterSale.js';
import { getEngineeringDepartment } from '@/utils/base/staff.js';
import { PQCProductOption } from '@/views/productDaily/serve/option';
import { questionTypeOptions } from '@/views/afterSaleRepair/pc/data';
import websocket from "@/utils/base/socket";
import seriesTypeCascader from '@/components/cascader/index.vue';
import afterSaleQeustionVue from "@/views/repair/components/afterSaleQeustion.vue";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";
import staff from '@/components/chooseStaff/staff.vue';
import { useRoute } from "vue-router";

export default defineComponent({
    components: { uploadImgVue, uploadVideoVue, afterSaleQeustionVue, seriesTypeCascader, staff },
    setup(props, context) {
        const formRef = ref();
        const questionRef = ref();
        const uploadImg = ref();
        const uploadVideo = ref();

        const user = useStore().state.user.user;
        const route = useRoute();

        const useNotice = reactive({
            recipient: false,
            analysisDept: false,
            executionDept: false,
        });

        const rootCauseAnalysisOptions = reactive([]);

        const noticeMsg = ref(null);

        const formState = reactive({
            analysisDept: null,
            closedLoopMeasures: null,
            confirmationAndAnalysis: null,
            rootCauseAnalysisTemplateId: null,
            createUserId: null,
            executionDept: null,
            feedbackDate: null,
            feedbackDept: null,
            id: null,
            implementationMeasures: null,
            model: null,
            notes: null,
            picture: null,
            problemPhenomenon: null,
            problemType: null,
            produceDate: null,
            produceOrTpc: route.meta.produceOrTpc,
            recipient: null,
            rootCauseAnalysis: null,
            serial: null,
            status: null,
            submittedBy: null,
            submittedDate: null,
            submittedProcess: null,
            supervisionDept: null,
            temporaryMeasures: null,
            video: null
        });

        const getAfterSaleProblemDescription = () => {
            return questionRef.value.questionList.reduce((a, b) => a + `${b.value}#`, '').replace(/(.*)#/, '$1');
        };

        const validateProblemPhenomenon = async (rule, value) => {
            const problemDescription = getAfterSaleProblemDescription().replace(/#/g, '');
            if (problemDescription === '') {
                return Promise.reject(rule.message);
            }
            return Promise.resolve();
        };

        const rules = reactive({
            problemType: [{ required: false, message: '请选择问题类型', trigger: 'change' }],
            confirmationAndAnalysis: [{ required: false, message: '请输入情况确认和分析', trigger: 'change' }],
            rootCauseAnalysisTemplateId: [{ required: false, message: '请选择根本原因分析', trigger: 'change', type: 'number' }],
            problemPhenomenon: [{ required: true, message: '请输入问题现象', validator: validateProblemPhenomenon, trigger: 'change' }],
            produceDate: [{ required: true, message: '请选择生产日期', trigger: 'change' }],
            serial: [{ required: true, message: '请输入机器信息', trigger: 'change' }],
            model: [{ required: true, message: '请选择设备型号', trigger: 'change' }],
            submittedProcess: [{ required: true, message: '请选择送检工序', trigger: 'change' }],
            submittedBy: [{ required: true, message: '请输入送检人', trigger: 'change' }],
            submittedDate: [{ required: true, message: '请选择送检日期', trigger: 'change' }],
        });

        const modalConfig = reactive({
            role: null,
            visible: false,
            title: null,
            type: null,
        });

        const setAnalysisData = () => {
            getRootCauseAnalysisTemplateList().then((res) => {
                rootCauseAnalysisOptions.length = 0;
                if (res.code === 200 && res.message === '成功') {
                    res.data.forEach((item) => {
                        rootCauseAnalysisOptions.push({
                            label: item.rootCauseAnalysis,
                            value: item.id,
                            ...item
                        });
                    });
                }
            });
        };

        const showModal = (type, options) => {
            const { title, data, role } = options;
            if (type === "edit" || type === 'analysis') {
                setAnalysisData();
                Object.keys(formState).forEach((key) => {
                    if (key === 'problemPhenomenon') {
                        const list = [];
                        data.problemPhenomenon.split('#').forEach((str) => {
                            list.push({
                                value: str,
                                disabled: type === 'analysis',
                            })
                        });
                        formState.problemPhenomenon = JSON.stringify(list)
                        return;
                    }
                    formState[key] = data[key];
                });
            }

            if (type === "insert") {
                formState.feedbackDate = timeStampToTime('', 'upload');
                formState.createUserId = user.id;
                formState.feedbackDept = `${user.firstLevelDepartment}${user.nickName}`;
            }

            if (type === 'analysis' && formState.status !== '分析中') {
                formState.analysisDept = `${user.firstLevelDepartment}${user.nickName}`;
                formState.status === '分析中';
            }

            if (formState.status === '分析中' || formState.status === '进行中') {
                rules.problemType[0].required = true;
                rules.confirmationAndAnalysis[0].required = true;
                rules.rootCauseAnalysisTemplateId[0].required = true;
            }

            modalConfig.title = title;
            modalConfig.role = role;
            modalConfig.visible = true;
            modalConfig.type = type;

            console.log(formState, 'formState');
        };


        const handleCancel = () => {
            resetForm();
            questionRef.value.resetList();
            modalConfig.title = null;
            modalConfig.visible = false;
            modalConfig.role = null;
            modalConfig.type = null;
            noticeMsg.value = null;
            useNotice.recipient = false;
            useNotice.analysisDept = false;
            useNotice.executionDept = false;
        };

        const resetForm = () => {
            Object.keys(formState).forEach((key) => {
                formState[key] = null;
            });
            formState.produceOrTpc = route.meta.produceOrTpc;
            formRef.value.clearValidate();
        };

        // websocket通知
        const websocketNotice = (toUserId, msg) => {
            if (user.id == toUserId) return;

            return websocket.Send({
                content: msg,
                query: JSON.stringify({
                    serial: formState.serial,
                    activeKey: 'qualityInspection',
                    type: "link",
                }),
                route: route.path,
                messageSort: '质检问题',
                toUserId,
                type: 0,
                userId: user.id,
            });
        };

        // 发送通知
        const handleSendMsg = () => {
            const step = {
                recipient: "处理",
                analysisDept: "确认和分析反馈问题",
                executionDept: "查收执行措施",
            };
            Object.keys(useNotice).forEach((key) => {
                if (useNotice[key]) {
                    const [userName, id] = formState[key].split(',');
                    let msg = `${user.nickName}推送 质检问题 请${step[key]}`;
                    if (key === 'recipient') msg = `${msg}${noticeMsg.value ? noticeMsg.value : ""}`;
                    websocketNotice(id, msg);
                }
            });
        };

        const handleOk = debounce(() => {
            // 售后问题
            const problemPhenomenon = getAfterSaleProblemDescription();

            const payload = Object.assign({}, formState);
            payload.problemPhenomenon = problemPhenomenon;

            formRef.value
                .validateFields()
                .then(async (res) => {
                    // 上传文件
                    if (uploadImg.value && uploadVideo.value) {
                        await uploadMedia(uploadImg, uploadVideo).then((res) => {
                            const [picture, video] = res;
                            payload.picture = picture.join(',');
                            payload.video = video.join(',');
                        }).catch((err) => {
                            console.log(err, '++++++++');
                        });
                    }

                    switch (modalConfig.type) {
                        case 'insert':
                            const department = process.env.NODE_ENV === 'production' ? '试产中心' : '工程部';
                            await getEngineeringDepartment(department).then((res) => {
                                const { id, nickName } = res;
                                formState.recipient = `${nickName},${id.slice(1)}`;
                                websocketNotice(id.slice(1), `${user.nickName}推送 质检问题 请处理`);
                            });
                            break;
                        default:
                            break;
                    }

                    handleSendMsg();

                    saveQualityInspectionProblem(payload).then((res) => {
                        const type = res.code === 200 ? "success" : "warning";
                        Toast(type, res.message, 3);
                        handleCancel();
                        context.emit("handleUpdateTable");
                    });
                })
                .catch((err) => {
                    console.log(err, '++++++++++++++')
                    if (err && err.errorFields) {
                        const [errText] = err.errorFields[0].errors;
                        Toast("warning", errText, 3);
                    }
                });
        });
        const handleSelectRootTemplate = (e, options) => {
            if (options) {
                Object.keys(options).forEach((key) => {
                    if (key !== 'lebel' && key !== 'id') {
                        formState[key] = options[key];
                    }
                })
            } else {
                formState.implementationMeasures = null;
                formState.rootCauseAnalysis = null;
                formState.temporaryMeasures = null;
                formState.closedLoopMeasures = null;
                formState.rootCauseAnalysisTemplateId = null;
            }
        };
        // 选择任务负责人
        const chooseStaff = (data, type) => {
            const { staffUserName, structureName } = data;
            formState[type] = `${structureName[0]}-${staffUserName[0]}`;
        };
        // 选择通知人
        const getChooseStaff = (data, key) => {
            const {
                idList,
                staffName,
                staffUserName,
                structureName,
            } = data;

            const [id] = idList;
            const [username] = staffUserName;
            const [department] = structureName;

            if (!username) return;

            const selectValue = `${username},${id},${department}`;
            if (selectValue === formState[key]) return;
            formState[key] = selectValue;
            useNotice[key] = true;
        };

        return {
            formState,
            PQCProductOption,
            rules,
            formRef,
            noticeMsg,
            useNotice,
            questionTypeOptions,
            rootCauseAnalysisOptions,
            uploadQualityInspection,
            handleSelectRootTemplate,
            showModal,
            handleCancel,
            toRaw,
            handleOk,
            chooseStaff,
            getChooseStaff,
            questionRef,
            modalConfig,
            uploadImg,
            uploadVideo,
        };
    },
});
</script>

<style lang="less" scoped>
:deep(.ant-cascader-picker-disabled) {
    color: #000;
}

.line {
    height: 2px;
    background: #ccc;
    width: 95%;
    margin-bottom: 20px;
    margin-left: 5%;
}

:deep(.ant-form-item) {
    margin-bottom: 10px;
}
</style>
